export default __webpack_public_path__ + "static/media/K_Deegan_262.28606246.jpg";